import * as S from './styles';
import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';
import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';
import TituloGenerico from '@/components/atoms/TituloGenerico';
import { ConteudoRecomendacao } from '@/services/types/recomendacao';
import Text from '@/components/atoms/Text';
import { TamanhosCartaz } from '@/components/atoms/Cartaz';
import { usePaginacaoScrollHorizontal } from '@/hooks/usePaginacaoScrollHorizontal';
import { Ref } from 'react';
import IconButton from '@/components/atoms/IconButton';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import useBreakpoint from '@/hooks/useBreakpoint';
import { registrarEvento } from '@/services/googleAnalytics';

interface ListagemTitulosProps {
  $titulo?: string;
  $esconderTitulo?: boolean;
  $conteudos: ConteudoRecomendacao[] | null | undefined;
  $carregandoConteudos: boolean;
  $paddingLeft?: number;
  $ranking?: boolean;
  $tamanhoCartaz?: TamanhosCartaz;
}

export default function ListagemTitulos(props: ListagemTitulosProps) {
  const {
    $titulo,
    $esconderTitulo = false,
    $conteudos = [],
    $carregandoConteudos,
    $paddingLeft = 0,
    $ranking = false,
    $tamanhoCartaz = 'medio',
  } = props;

  const { breakpoint } = useBreakpoint();

  const {
    viewportRef,
    scrollContainerRef,
    itemRef,
    lidarComScroll,
    paginaAtual,
    totalPaginas,
    irParaPaginaAnterior,
    irParaProximaPagina,
  } = usePaginacaoScrollHorizontal({
    gap: theme.spacing[5],
    totalItens: $conteudos?.length,
  });

  return (
    <S.Container ref={viewportRef}>
      {$titulo && !$esconderTitulo ? (
        <Text
          $size={6}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={$titulo}
        />
      ) : null}
      <S.ContainerScroll>
        {breakpoint !== 'mobile' &&
        paginaAtual > 1 &&
        paginaAtual <= totalPaginas ? (
          <S.ContainerButtonArrow
            $position="esquerda"
            $paddingLeft={$paddingLeft}
          >
            <IconButton
              $size={2}
              $state="default"
              $variant="solid"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $Icon={IconeSeta}
              $iconProps={{ direcao: 'esquerda' }}
              $focusRing={false}
              aria-label="Botao Ver Foto Anterior"
              $onClick={() => {
                registrarEvento('cliqueScrollHorizontalVoltar', {
                  lane: $titulo,
                });
                irParaPaginaAnterior();
              }}
              $mostrarEstilizacaoHover={false}
              style={{
                borderRadius: '50%',
              }}
            />
          </S.ContainerButtonArrow>
        ) : null}
        <ScrollAreaContainer
          refScrollAreaViewport={scrollContainerRef}
          orientacao="horizontal"
          lidarScroll={() => {
            lidarComScroll($titulo);
          }}
        >
          <S.ContainerListagemHorizontal $tamanhoCartaz={$tamanhoCartaz}>
            {$carregandoConteudos
              ? Array.from({ length: 10 }).map((item, index) => (
                  <Skeleton
                    key={`${item}_${index}`}
                    style={{
                      height: $ranking ? 383 : 307,
                      width: theme.tamanhoCartaz.width[$tamanhoCartaz],
                    }}
                  />
                ))
              : $conteudos?.map((conteudo, index) => (
                  <TituloGenerico
                    $eventoAnalytics={() => {
                      registrarEvento('cliqueCartazLane', {
                        lane: $titulo,
                        ficha: conteudo.titulo,
                      });
                    }}
                    ref={index === 0 ? (itemRef as Ref<HTMLDivElement>) : null}
                    key={conteudo.tituloID}
                    $image={conteudo?.titulo?.posterArquivo?.urlx3}
                    $nome={conteudo?.titulo?.titulo}
                    $notaEstrela={
                      conteudo.titulo.nota
                        ? Number(conteudo.titulo.nota.toFixed(1))
                        : 0
                    }
                    $notaChippu={
                      conteudo.titulo.notaComunidade
                        ? Number(conteudo.titulo.notaComunidade.toFixed(1))
                        : 0
                    }
                    $link={`/ficha/${conteudo?.titulo?.slug}`}
                    $posicao={$ranking ? index + 1 : undefined}
                    $tamanhoCartaz={$tamanhoCartaz}
                  />
                ))}
          </S.ContainerListagemHorizontal>
        </ScrollAreaContainer>
        {breakpoint !== 'mobile' && paginaAtual < totalPaginas ? (
          <S.ContainerButtonArrow
            $position="direita"
            $paddingLeft={$paddingLeft}
          >
            <IconButton
              $size={2}
              $state="default"
              $variant="solid"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $Icon={IconeSeta}
              $iconProps={{ direcao: 'direita' }}
              $focusRing={false}
              aria-label="Botao Ver Foto Anterior"
              $onClick={() => {
                registrarEvento('cliqueScrollHorizontalAvancar', {
                  lane: $titulo,
                });
                irParaProximaPagina();
              }}
              $mostrarEstilizacaoHover={false}
              style={{
                borderRadius: '50%',
              }}
            />
          </S.ContainerButtonArrow>
        ) : null}
      </S.ContainerScroll>
    </S.Container>
  );
}
